import React from "react";
import { useState } from "react";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";

import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";
import { fetchContactUs } from "../../../services/api-raindrop.js";

const ContactUsForm = () => {
  const [inputName, setInputName] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [inputMessage, setInputMessage] = useState("");

  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);

  const onSubmit = () => {
    setIsSending(true);
    fetchContactUs({
      name: inputName,
      email: inputEmail,
      message: inputMessage,
    })
      .then((data) => {
        console.log(data, "RD-666");
        if (data.ok) {
          setIsSent(true);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  if (isSent) {
    return (
      <div>
        We've sent your message. We'll try to respond as soon as we can. Thank
        you!
      </div>
    );
  }

  return (
    <form className="flex flex-col w-[600px] gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-3xl font-bold">Contact Us</h1>
        <p className="text-color-dark-text-secondary">
          We'd love to hear your thoughts and feedback. We'll get back to you as
          soon as we can.
        </p>
      </div>
      <RaindropInput
        title={"Name"}
        placeholder={"Your Name"}
        label="Name"
        isShowLabel={true}
        value={inputName}
        onChange={(e) => setInputName(e.target.value)}
        maxLength={100}
      />

      <RaindropInput
        label="Email"
        placeholder={"Your Email"}
        isShowLabel={true}
        value={inputEmail}
        onChange={(e) => setInputEmail(e.target.value)}
        maxLength={100}
      />
      <RaindropInputTextArea
        title={"Message"}
        placeholder={"Your Message"}
        label="Message"
        value={inputMessage}
        onChange={(e) => setInputMessage(e.target.value)}
        maxLength={1000}
      />
      <div className="flex flex-row">
        <Spacer />
        <RaindropButton
          title="Send"
          icon="fa-envelope"
          style={ButtonStyle.Primary}
          isLoading={isSending}
          onClick={onSubmit}
        />
      </div>
    </form>
  );
};

const StratusContactUs = () => {
  return (
    <div id={"page--about-us"}>
      <ContactUsForm />
    </div>
  );
};

export default StratusContactUs;
